import React, {Component} from 'react';
import {connect} from 'react-redux';
import {I18nProvider} from '@lingui/react';

import {getI18n} from '../../configurei18n';
import {updateCatalog} from '../../actions/settingActions.js';

const i18n = getI18n();

export class I18nLoader extends Component {
  state = {
    catalogs: {},
    language: this.props.language,
  };

  loadCatalog = async (language) => {
    const catalog = await import(
      /* webpackMode: "lazy", webpackChunkName: "i18n-[index]" */
      `../../locales/${language}/messages.js`
    );
    i18n.load({[language]: catalog});
    i18n.activate(language);
    this.props.updateCatalog(catalog);
    this.setState((state) => ({
      catalogs: {
        ...state.catalogs,
        [language]: catalog,
      },
    }));
  };

  componentDidMount() {
    this.loadCatalog(this.props.language);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const {language} = nextProps;
    const {catalogs} = nextState;

    if (language !== this.props.language && !catalogs[language]) {
      this.loadCatalog(language);
      return false;
    }

    return true;
  }

  render() {
    const {children} = this.props;
    const {catalogs, language} = this.state;

    // skip rendering if catalog is not loaded
    if (!catalogs[language]) return null;

    return (
      <I18nProvider i18n={i18n} language={language} catalogs={catalogs}>
        {children}
      </I18nProvider>
    );
  }
}

const mapStateToProps = ({appSettings}) => {
  return {
    language: appSettings.language,
  };
};

export default connect(mapStateToProps, {updateCatalog})(I18nLoader);
